<template>
  <v-form ref="form" v-model="valid" lazy-validation>
    <v-row>
      <v-col cols="12">
        <v-text-field
          v-model="organization.name"
          :counter="100"
          label="Name"
          :rules="nameRules"
          required
        ></v-text-field>
      </v-col>
      <v-col cols="12" v-if="!organization.isBaseOrganization">
        <v-select
          v-model="organization.parentOrganizationId"
          :items="organizations"
          item-text="name"
          item-value="id"
          label="Parent"
          :rules="[v => !!v || 'Parent is required']"
          required
          :readonly="organization.parentOrganizationId && ($route.params.organizationId == '00000000-0000-0000-0000-000000000000')"
        ></v-select>
      </v-col>
      <v-col cols="12" v-if="!organization.isBaseOrganization && organization.parentOrganizationId">
        <v-select
          v-model="organization.profileId"
          :items="organizationProfiles"
          item-text="name"
          item-value="id"
          label="Profile"
          :readonly="organization.profileId && ($route.params.organizationId == '00000000-0000-0000-0000-000000000000')"
        ></v-select>
        <v-col cols="12" v-if="organization.fields">
          <v-col cols="12" v-for="(field, index) in organization.fields" :key="index">
            <v-text-field
              v-model="field.value"
              :label="field.name"
              :rules="fieldRules(field)"
              :required="field.isRequired"
            ></v-text-field>
          </v-col>
        </v-col>
      </v-col>
      <v-col cols="12">
        <v-overlay :value="triggering">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>        
        <v-btn class="ma-2" color="success" @click="submit">save</v-btn>
        <v-btn class="ma-2" color="primary" @click="back">back</v-btn>
        <v-btn class="ma-2" color="warning" @click="trigger" 
          v-if="selectedProfile && selectedProfile.lookups && selectedProfile.lookups.length && !triggered && $route.params.organizationId == '00000000-0000-0000-0000-000000000000'">lookup</v-btn>
        <span>{{submitStatus}}</span>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
export default {
  props: ["me", "organization", "organizations", "organizationProfiles"],
  data: () => ({
    submitStatus: null,
    triggering: false,
    triggered: false,
    valid: false,
    nameRules: [
      v => !!v || "This field is required",
      v => (v && v.length <= 100) || "100 characters maximum"
    ]
  }),
  computed: {
    selectedProfile() {
      return this.organizationProfiles.find(
        x => x.id === this.organization.profileId
      );
    }
  },
  watch: {
    selectedProfile() {
      if (this.selectedProfile && this.selectedProfile.fields) {
        this.selectedProfile.fields.forEach(f => {
          this.organization.fields.push({
            id: '00000000-0000-0000-0000-000000000000',
            name: f.name,
            type: f.type,
            value: f.value,
            isRequired: f.isRequired
          });
        });
      }      
    }
  },
  methods: {  
    fieldRules(field) {
      if (!field.isRequired) return [];
      else {
        return [v => !!v || field.name + " is required"];
      }
    },
    submit() {
      if (!this.$refs.form.validate()) {
        this.submitStatus = "ERROR";
      } else {
        if (
          this.organization.id == undefined ||
          this.organization.id == "00000000-0000-0000-0000-000000000000"
        ) {
          this.submitStatus = "POSTING";
          this.$http
            .post("api/organizations/", {
              id: this.organization.id,
              name: this.organization.name,
              parentOrganizationId: this.organization.parentOrganizationId,
              profileId: this.organization.profileId,
              fields: this.organization.fields
              })
            .then(request => {
              if (request.status == 201) {
                if (request.data) this.$router.push({ name: "AdministrationOrganization", params: { organizationId: request.data } })
                else {
                  this.$emit("done");
                  this.submitStatus = "";
                }
              } else {
                this.submitStatus = "ERROR";
              }
            })
            .catch(e => {
             this.$root.$children[0].$emit("display-error", "1800", e);
              this.submitStatus = "ERROR";
            });
        } else {
          this.submitStatus = "PUTTING";
          this.$http
            .put("api/organizations/" + this.organization.id, {
              id: this.organization.id,
              name: this.organization.name,
              parentOrganizationId: this.organization.parentOrganizationId,
              profileId: this.organization.profileId,
              fields: this.organization.fields
              })
            .then(request => {
              if (request.status == 201) {
                this.$emit("done");
              } else {
                this.submitStatus = "ERROR";
              }
            })
            .catch(e => {
              this.$root.$children[0].$emit("display-error", "1801", e);
              this.submitStatus = "ERROR";
            });
        }
      }
    },
    back() {
      this.$router.push({ name: "AdministrationOrganizations" })
    },
    trigger() {
      this.submitStatus = "LOOKING UP";
      this.triggering = true;
      this.triggered = true;
      this.$http
        .post("api/lookups/trigger/" + this.selectedProfile.lookups[0].id, {
          id: '00000000-0000-0000-0000-000000000000',
          name: '',
          organizationId: this.organization.id,
          organization: {
              id: this.organization.id,
              name: this.organization.name,
              parentOrganizationId: this.organization.parentOrganizationId,
              profileId: this.selectedProfile.id,
              fields: this.organization.fields
              }
          })
        .then(request => {
          if (request.status == 200) {
            var result = request.data;
            if (result && result.hasResults) {
              this.submitStatus = "";
              if (result.matches.length && result.matches[0].value) {
                var data = result.matches[0].value.split(';');
                data.forEach(i => {
                  var kv = i.split('=');
                  if (kv[0].toLowerCase() == 'name') this.organization.name = kv[1];
                  else {
                    this.organization.fields.push({
                      "type":0,
                      "name":kv[0],
                      "description":null,
                      "settings":null,
                      "order":0,
                      "assetProfileId":"00000000-0000-0000-0000-000000000000",
                      "value":kv[1],
                      "isRequired":false,
                      "isReadOnly":false,
                      "isLookupField":false,
                      "showOnList":false,
                      "created":this.$moment().toISOString(),
                      "id":"00000000-0000-0000-0000-000000000000",
                      "modified":this.$moment().toISOString(),
                      "modifiedBy":null,
                      "modifiedById":null
                    })
                  }
                })
              }
            } else {
              this.triggering = false;
              this.triggered = false;
              this.submitStatus = "NO MATCH";
            }
            this.triggering = false;
          } else {
            this.triggering = false;
            this.triggered = false;
            this.submitStatus = "TRIGGER ERROR";
          }
        })
        .catch(e => {
          this.$root.$children[0].$emit("display-error", "1802", e);
          this.submitStatus = "ERROR";
          this.triggered = false;
          this.triggering = false;
        });      
    }
  }
};
</script>